import { ApToggleSwitch, colors } from '@alixpartners/ui-components';
import styled from 'styled-components';

export const TooltipContainer = styled.div`
	flex: 1;
	display: flex;
	flex-direction: column;
	padding: 8px 12px;
	margin: 0;
	z-index: 2;
	background-color: ${colors.white};
	#tooltip_content {
		display: flex;
		flex-direction: column;
	}
`;

export const TooltipItemTitle = styled.strong`
	font-size: 13px;
	font-weight: bold;
`;

export const FilterWrapper = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	column-gap: 1%;
	#price_filter,
	#keys_filter {
		border: 1px solid #cccccc;
	}
	#scale_marker_by_volume {
		display: flex;
		align-items: center;
	}
`;

export const ToggleSwitch = styled(ApToggleSwitch)`
	margin: 2px 0 0 3px;
`;
